import { Box, styled, Stack, AppBar as MuiAppBar } from '@mui/material';
import { SUB_HEADER_PAGE_ELEMENT_ID } from '../../constants';
import { NEW_COLORS } from '../../themes/colors/newColors';

const PageContainer = styled(Box)(() => ({
  display: 'flex',
}));

const MainContent = styled(Box)(() => ({
  flexGrow: 1,
  minWidth: 0,
  '& > *': {
    paddingRight: 24,
    paddingLeft: 24,
  },
  [`& #${SUB_HEADER_PAGE_ELEMENT_ID}`]: {
    padding: 24,
  },
}));

const StyledStack = styled(Stack)`
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  height: 100vh;
  flex: 1;
`;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop =>
    !['isBackofficeUser', 'isMobile'].includes(prop.toString()),
})<{
  isBackofficeUser?: boolean;
  isMobile?: boolean;
}>(({ isBackofficeUser, isMobile }) => ({
  justifyContent: 'center',
  boxShadow: 'none',
  background: isBackofficeUser
    ? NEW_COLORS.GRAYSCALE[800]
    : NEW_COLORS.BASE.WHITE,
  minHeight: isMobile ? '60px' : '109px',
  borderBottom: isBackofficeUser
    ? 'transparent'
    : `1px solid ${NEW_COLORS.GRAYSCALE[200]}`,
}));

export { AppBar, StyledStack, MainContent, PageContainer };
